import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
export async function GetPolls(
    projectId,
    status = '',
    type = '',
    page = 1,
    search = '',
    timezone = '',
    sortBy = '',
    sortOrder = ''
) {
    const user = store?.getState()?.user;
    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${
                process.env.REACT_APP_MYXP_API_V2
            }/manager/livestream/polls?projectId=${projectId}&status=${status}&limit=10&type=${type}&page=${page}&search=${search}&timezone=${timezone}${
                sortBy ? `&sortBy=${sortBy}` : ''
            }${sortOrder ? `&sortOrder=${sortOrder}` : ''}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return await response.json();
    }
}
